import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getYouTubePlaylists } from "./action";

export const youtubePlayListEntityAdapter = createEntityAdapter({
  selectId: (entity) => `${entity.profileId}_${entity.id}`,
});
const initialState = youtubePlayListEntityAdapter.getInitialState({
  loading: false,
  error: null,
});

export const youtubeSlice = createSlice({
  name: "youtube",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getYouTubePlaylists.fulfilled, (state, action) => {
      try {
        const { data } = action.payload;
        const profileId = action.meta.arg.payload.profileId;
        if (data?.playLists && profileId) {
          const playlistsWithProfile = data?.playLists?.map((playlist) => ({
            ...playlist,
            profileId,
          }));

          youtubePlayListEntityAdapter.upsertMany(state, playlistsWithProfile);
        }
      } catch (error) {
        console.log(error);
      }
    });
  },
});

export default youtubeSlice.reducer;
